// extracted by mini-css-extract-plugin
export default {"container":"ScalesPage_container__2dyuW","header":"ScalesPage_header__r0K7L","scalesList":"ScalesPage_scalesList__G4A1l"};